module.exports = __webpack_public_path__ + "static/img/des5.7452bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/des5.jpg
// module id = f7vN
// module chunks = 0